import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

import {DownloadButtonsComponent} from '@core/components/download-buttons/download-buttons.component';

@NgModule({
  declarations: [DownloadButtonsComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    CommonModule,
  ],
  exports: [DownloadButtonsComponent]
})
export class DownloadButtonsModule {}
